<template>
	<div>
		<el-header>
			<el-form
					:inline="true"
					:model="searchForm"
					class="search-form"
			>
				<el-form-item label="项目选择" label-width="80px">
					<el-select
							v-model="projectId"
							placeholder="请选择项目"
							@change="handleProjectChange"
							style="width: 320px"
							clearable
					>
						<el-option
								v-for="item in projectList"
								:key="item.value"
								:label="item.label"
								:value="item.value"
								:data="item"
						></el-option>
					</el-select>
					<el-button
							type="primary"
							@click="handleProjectUpdate"
							:loading="projectLoading"
					>
						刷新
					</el-button>
				</el-form-item>
			</el-form>
		</el-header>
		<el-container class="collect-list">
			<el-main>
<!--				<el-row :gutter="20" v-if="unConfirmedOpinions&&unConfirmedOpinions.length>0">-->
				<el-row :gutter="30" >
					<el-col :span="12">
						<el-card  style="height: 78vh; ">
							<div slot="header">
								<span>待汇总意见</span>
							</div>
							
							<el-tabs v-model="activeName" @tab-click="handleClick">
								<el-tab-pane
										:key="item.name"
										v-for="(item, index) in editableTabs"
										:label="item.userName"
										:name="`${item.userId.toString()}`"
								>
								</el-tab-pane>
							</el-tabs>
							
							
								<el-table
										:data="unConfirmedOpinions"
										style="width: 100%;margin-bottom: 20px;"
										height="60vh"
										v-if="unConfirmedOpinions&&unConfirmedOpinions.length>0"
								>
									<el-table-column prop="userName" label="" width="" >
										<template slot-scope="scope">
											<div style="padding:10px;">
												{{ scope.$index+1+'、' }}{{ scope.row.questionTypeName||'' }}
												<div v-for="(item, index) in scope.row.opinionSummaryUnconfirmedList||[]" >
													<div style="height:10px"></div>
													<div style=" line-height: 1.8; padding:0 10px;">
														<div >
															<el-tag size="small" type="danger">{{ item.userNames || '' }}</el-tag>
														</div>
														<div  style="display: flex;align-items: center;justify-content: space-between;">
															<div >
																<el-button
																		type="text"
																		@click="handlePreview(item)"
																>
																	{{'位置：'+ item.drProjectFilePath?item.drProjectFilePath:item.spatialRefList}}
																</el-button>
															</div>
															<div>
																<el-button
																		type="primary"
																		size="small"
																		v-if="!item.isConfirmed"
																		@click="handleOnAdd(item)"
																>
																	{{'确认'}}
																</el-button>
																<el-button
																		type="success"
																		size="small"
																		v-if="!item.isConfirmed"
																		@click="handleOnAddConfirm(item)"
																>
																	{{'认可'}}
																</el-button>
																<el-button
																		type="text"
																		v-else
																		@click="handlePreview(item)"
																>
																	{{'查看截图'}}
																</el-button>
															</div>
														</div>
														<div style="">
															
															<span>{{ index + 1 + '、 ' + item.confirmProblem }},{{item.drStandardItemDescribe}}({{item.ddIdQuestionPropertieValue}})</span>
															<span class="tag-itemType" style="background-color: #f56c6c;" v-if="item.itemType===1">重要事项</span>
															<span class="tag-itemType" style="background-color: #e6a23c; " v-if="item.itemType===9">其他事项</span>
															<span class="tag-itemType" style="background-color: #67c23a; " v-if="item.itemType===99">提示事项</span>
															<span class="tag-itemType" style="background-color: #909399;" v-if="item.itemType===0">无</span>
														</div>
													</div>
												</div>
											</div>
										</template>
									</el-table-column>
								
								</el-table>
								<el-skeleton v-else animated style="width: 100%; height: 50px;" />
							
						</el-card>
					</el-col>
					<el-col :span="12">
						<el-card  style="height: 78vh; ">
							<div slot="header">
								<span>已汇总意见</span>
							</div>
							<el-table
									:data="confirmedOpinions"
									style="width: 100%;margin-bottom: 20px;"
									height="65vh"
									v-if="confirmedOpinions&&confirmedOpinions.length>0"
							>
								<el-table-column prop="userName" label="" width="" >
									<template slot-scope="scope">
										<div style="padding:10px;">
											{{ scope.$index+1+'、' }}{{ scope.row.questionTypeName||'' }}
											<div v-for="(item, index) in scope.row.opinionSummaryConfirmedList||[]" >
												<div style="height:10px"></div>
												<div style=" line-height: 1.8; padding:0 10px;">
													<div >
														<el-tag size="small" type="danger">{{ item.userNames || '' }}</el-tag>
													</div>
													<div v-if="item.userNames !== 'AI机器人'" style="display: flex;align-items: center;justify-content: space-between;">
														<div >
															<el-button
																	type="text"
																	@click="handlePreview(item)"
															>
																{{'位置：'+ item.drProjectFilePath}}
															</el-button>
														</div>
														<div>
															
															<el-button
																	type="text"
																	@click="handlePreview(item)"
															>
																{{'查看截图'}}
															</el-button>
														</div>
													</div>
													<div style="">
														
														<span>{{ index + 1 + '、 ' + item.confirmProblem }},{{item.drStandardItemDescribe}}({{item.ddIdQuestionPropertieValue}})</span>
														<span class="tag-itemType" style="background-color: #f56c6c;" v-if="item.itemType===1">重要事项</span>
														<span class="tag-itemType" style="background-color: #e6a23c; " v-if="item.itemType===9">其他事项</span>
														<span class="tag-itemType" style="background-color: #67c23a; " v-if="item.itemType===99">提示事项</span>
														<span class="tag-itemType" style="background-color: #909399;" v-if="item.itemType===0">无</span>
													</div>
													<div style="margin-top: 10px;">
														<el-input v-if="editConfirmDialog&&editConfirmId===item.id" v-model="editConfirmContent" placeholder="请输入内容"></el-input>
														<div v-if="editConfirmDialog&&editConfirmId===item.id" style="margin-top: 10px;">
															<el-button
																	type="primary"
																	size="small"
																	@click="handleOnConfirm(item)"
															>
																{{'确认'}}
															</el-button>
															<el-button
																	
																	size="small"
																	@click="handleOnCancle(item)"
															>
																{{'取消'}}
															</el-button>
														</div>
														<div 	v-else>
															<el-button
																	type="primary"
																	size="small"
																	
																	@click="handleOnEdit(item)"
															>
																{{'编辑'}}
															</el-button>
															<el-button
																	type="danger"
																	size="small"
																	@click="handleOnDelete(item)"
															>
																{{'删除'}}
															</el-button>
														</div>
														
													</div>
												</div>
											</div>
										</div>
									</template>
								</el-table-column>
							
							</el-table>
							<el-skeleton v-else animated style="width: 100%; height: 50px;" />
							
						</el-card>
					</el-col>
				</el-row>
				<el-empty
						v-if="!(unConfirmedOpinions&&unConfirmedOpinions.length>0)"
						description="暂无待汇总项目"
						class="empty-container"
				></el-empty>
				
				
			</el-main>
			
			<el-footer style="text-align: center;z-index: 999;margin-top: -60px"   >
				<el-button
						type="primary"
						icon="el-icon-s-data"
						@click="opinionSimplification"
						:loading="loading"
						v-if="tiaoLength||xiangLength"
				>
					简化意见
				</el-button>
				<el-button
						type="primary"
						icon="el-icon-s-data"
						@click="generateReport"
						:loading="loading"
						v-else
				>
					生成初审/复核报告
				</el-button>
			</el-footer>
		</el-container>
		
		<!-- 预览图片弹窗 -->
		<el-dialog
				title="意见截图预览"
				:visible.sync="previewOpen"
				width="80%"
				@close="handleCancel"
				modal-append-to-body
				draggable
		>
			<div class="preview-img-container">
				<img
						:src="previewImage"
						:alt="previewTitle || '意见截图'"
				/>
				<el-skeleton v-if="!previewImage" animated style="width: 100%; height: 600px;" />
			</div>
		</el-dialog>
		
		
		<el-dialog
				title="提示"
				:visible.sync="open"
				:before-close="handleDeleteCancel"
				width="380px"
				modal-append-to-body
		>
			<div class="delete-tip">
				<el-icon class="delete-icon" color="#f56c6c" size="20"></el-icon>
				<span>确定要删除该条确认意见吗？删除后将无法恢复！</span>
			</div>
			<span slot="footer" class="dialog-footer">
        <el-button @click="handleDeleteCancel">取消</el-button>
        <el-button type="danger" @click="_deleteOpinion">确定删除</el-button>
      </span>
		</el-dialog>
		
		<el-dialog title="生成初审/复核报告" :visible.sync="reportDialog" width="35%" modal-append-to-body>
			<el-table
					ref="multipleTable"
					:data="standardList || []"
					tooltip-effect="dark"
					style="width: 100%; height: 66vh; overflow-y: auto;"
					@current-change="handleCurrentChange"
					@selection-change="handleSelectionChange">
				<el-table-column
						type="selection"
						width="55">
				</el-table-column>
				<el-table-column
						label=""
						width=""
						show-overflow-tooltip
				>
					<template slot-scope="scope">
						<div style="padding:5px 10px;">
							{{ scope.row.name }}
						</div>
					</template>
				</el-table-column>
			
			</el-table>
			<span slot="footer" class="dialog-footer">
	        <el-button @click="reportDialog = false">取 消</el-button>
	        <el-button type="primary" @click="confirmOpinion">确认审查意见</el-button>
	        <el-button type="primary" @click="previewReport">预览报告</el-button>
	        <el-button type="primary" @click="generateReportEnd">生成报告</el-button>
        </span>
		</el-dialog>
		
		
		<el-dialog title="确认审查意见" :visible.sync="confirmOpinionDialog" width="50%" modal-append-to-body>
			<el-table
					ref="multipleTableConfirm"
					:data="confirmOpinionList || []"
					tooltip-effect="dark"
					style="width: 100%; height: 66vh; overflow-y: auto;"
					@current-change="handleCurrentConfirmChange"
					@selection-change="handleSelectionConfirmChange">
				<el-table-column
						type="selection"
						width="55">
				</el-table-column>
				<el-table-column
						label=""
						width=""
						
				>
					<template slot-scope="scope">
						<div style="padding:5px 10px;">
							{{ scope.row.confirmProblem+scope.row.drStandardItemDescribe }}
						</div>
					</template>
				</el-table-column>
			
			</el-table>
			<span slot="footer" class="dialog-footer">
	        <el-button @click="confirmOpinionDialog = false">取 消</el-button>
	        <el-button type="primary" @click="confirmOpinionDialog = false">确认</el-button>
	        
        </span>
		</el-dialog>
		<el-dialog title="生成报告" :visible.sync="reportGenDialog" width="70%" modal-append-to-body>
			<iframe :src="'https://view.officeapps.live.com/op/view.aspx?src='+pdfUrl"
			 style="width: 100%; height: 100vh; overflow: auto;"></iframe>
		</el-dialog>
		
		<el-dialog
				title="简化相同问题"
				:visible.sync="opened"
				width="85%"
				:close-on-click-modal="false"
				@close="handleClose"
		>
			<!-- 内容区域 -->
			<div >
				<div >
					
						<!-- 空数据提示 -->
						<div slot="empty" class="empty-text">暂无合并意见</div>
						
						<div v-for="(item, index) in item" :key="item.drQuestionId">
							<div>
								<!-- 标题 -->
								<div slot="title" class="list-title">
									{{ index + 1 }}、{{ item.ddIdQuestionTypeValue }}
								</div>
								<!-- 描述内容 -->
								<div slot="description">
									<div style="margin-bottom: 20px">
										<!-- 原始意见列表 -->
										<div
												v-for="(opinion, idx) in item.opinionSummaryList"
												:key="idx"
												class="opinion-item"
												v-if="item.opinionSummaryList.length > 1"
										>
											<el-tag type="danger">
												提出人：<span>{{ userNames(opinion.userNames) }}</span>
											</el-tag>
											<span>{{ opinion.confirmProblem }}</span>
										</div>
										
										<!-- 合并后意见 -->
										<div>
											<el-tag type="danger">合并后意见</el-tag>
											{{ item.confirmProblem !== '' ? item.confirmProblem : getMergedOpinion(item) }}。
											以上问题{{ item.drStandardItemDescribe }}（{{ item.ddIdQuestionPropertieValue }}）
										</div>
										
										<!-- 编辑/保存区域 -->
										<div style="margin-top: 10px;">
											<!-- 编辑状态 -->
											<div v-if="item.id === editIdQ">
												<el-input
														type="textarea"
														:rows="4"
														v-model="editValueQuestion"
														style="width: 100%;"
												></el-input>
												<div style="margin-top: 10px;">
													<el-button type="primary" style="margin-right: 20px" @click="onSaveMerg(item)">
														确认
													</el-button>
													<el-button @click="onCancelQ">取消</el-button>
												</div>
											</div>
											
											<!-- 非编辑状态 -->
											<div v-else>
												<el-button type="primary" style="margin-right: 20px" @click="onEditQuestion(item)">
													编辑
												</el-button>
											</div>
										</div>
										
										<el-divider />
									</div>
								</div>
							</div>
						</div>
				</div>
			</div>
			
			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button
						type="primary"
						
						v-if="tiaoLength"
						@click=" tiaoDialogs "
				>
					{{ '下一步' }}
				</el-button>
				<el-button
						type="primary"
						:loading="confirmLoading"
						v-else
						@click="generateReport"
				>
					{{ '生成初审/复核报告' }}
				</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog
				title="简化相同条款"
				:visible.sync="opendTiao"
				:width="'85%'"
				custom-class="tiao-dialog"
				:close-on-click-modal="false"
				@close="handleCloseTiao"
		>
			<!-- 弹窗内容区域 -->
			<div class="modal-content">
				<div
						v-for="(item, index) in items"
						:key="item.drQuestionId"
				>
					<div >
						<div>
							<!-- 标题 -->
							<div slot="title" class="list-title">
								{{ index + 1 }}、{{ item.ddIdQuestionTypeValue }}
							</div>
							
							<!-- 描述内容 -->
							<div slot="description" class="list-desc">
								<div class="desc-item" :key="item.id">
									<!-- 原始意见列表 -->
									<div
											v-for="(opinion, idx) in item.opinionSummaryReportList"
											:key="idx"
											class="opinion-item"
									>
										<el-tag type="danger">
											提出人：
											<span>
                      {{ opinion.opinionSummaryList
													.filter(item => item.userNames)
													.map(item => {
														const userNameParts = item.userNames.split('-');
														return userNameParts[0];
													})
													.join(' ') }}
                    </span>
										</el-tag>
										<span class="opinion-content">{{ opinion.confirmProblem }}</span>
									</div>
									
									<!-- 合并后意见 -->
									<div class="merge-opinion">
										<el-tag type="danger">合并后意见</el-tag>
										<span>
                    {{ getMergedProblem(item) }}。
                    以上问题{{ item.drStandardItemDescribe }}（{{ item.ddIdQuestionPropertieValue }}）
                  </span>
									</div>
									
									<!-- 编辑/保存区域 -->
									<div class="edit-btns">
										<!-- 编辑状态 -->
										<div v-if="item.id === editIdQ">
											<el-input
													type="textarea"
													:rows="4"
													v-model="editValueQuestion"
													class="edit-textarea"
											></el-input>
											<div class="btn-group">
												<el-button type="primary" @click="onSaveMerg(item)">确认</el-button>
												<el-button @click="onCancelQ">取消</el-button>
											</div>
										</div>
										
										<!-- 查看状态 -->
										<div v-else>
											<el-button type="primary" @click="onEditQuestionTiao(item)">编辑</el-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 弹窗底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button
						type="primary"
						@click="onNext"
						:disabled="disabled"
						:loading="tiaoDialog"
				>
					生成初审/复核报告
				</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
// 引入API请求方法（需根据实际项目调整路径）
import {
	addOpinionConfirmed,
	deleteConfirmedOpinion,
	generatePreliminaryReviewReport,
	getDrOpinionSummaryConfirmed,
	getDrStandardList,
	getMergeOpinionSummaryReportListByStepOne,
	getMergeOpinionSummaryReportListByStepTwo,
	getOpinionSummaryReportList,
	getPeopleCount,
	getProjectById,
	getProjectListByUngather,
	getQuesTypeSummaryUnconfirmed,
	getQuesTypeSummaryUnconfirmedForUser,
	reportPreview,
	updateConfirmedOpinion,
	updateConfirmProblemByOpinionSummaryReport,
	updateShowOpinionSummaryReport
} from "@/api/api";
// 引入Element图标


export default {
	
	
	data() {
		return {
			tiaoDialog:false,
			
			
			opened: false,
			opendTiao: false,
			confirmLoading: false,
			disabled: false,
			tiaoLength: false,
			xiangLength: false,
			
			
			// 合并意见去重集合
			uniqueConfirmProblems: new Set(),
			
			
			pdfUrl:undefined,
			standardIds:undefined,
			standardList:undefined,
			selectedList:undefined,
			reportDialog: false,
			reportGenDialog: false,
			editConfirmDialog:false,
			editableTabs:[
				{
					userId: '-',
					userName: '自动汇总'
				},
			],
			activeName: '-',
			searchForm: {},
			projectId: undefined,
			projectLoading:false,
			curProject: null,
			projectList: [],
			list: [],
			opinions: [],
			unConfirmedOpinions: [],
			confirmedOpinions: [],
			previewOpen: false,
			previewTitle: "",
			previewImage: "",
			open: false,
			removeOpinion: undefined,
			editId: undefined,
			editIdQ: undefined,
			editValue: "",
			editValueQuestion: "",
			loading: false,
			item: [], // 步骤二合并列表
			items: [], // 步骤一合并列表
			projectOne: {},
			percent: 0,
			editConfirmContent:undefined,
			editConfirmId:undefined,
			multipleSelection: [],
			confirmOpinionDialog:false,
			confirmOpinionList: [],
		};
	},
	created() {
		this.init();
	},
	watch: {
		projectId(val) {
			if (val) {
				this.xiangTiao(val);
			}
		}
	},
	methods: {
		
		handleClose() {
		
		},
		// 关闭弹窗
		handleCloseTiao() {
			// this.$emit('update:opendTiao', false);
		},
		// 下一步
		onNext() {
			// this.$emit('onNext');
		},
		
		
		// ✅ 核心：合并意见逻辑（完全复刻原React逻辑）
		getMergedProblem(item) {
			// 有手动填写的值，直接返回
			if (item.confirmProblem !== '' && item.confirmProblem !== 'null') {
				return item.confirmProblem;
			}
			
			// 特殊问题配置
			const specialProblems = [
				'未提供场所',
				'未提供符合消防法律法规和消防技术标准规定设计内容的场所',
				'未提供按照国家制图标准和图例绘制的场所'
			];
			
			// 过滤有效意见
			const validOpinions = item.opinionSummaryReportList.filter(
					opinion => opinion.confirmProblem
			);
			
			const specialProblemMap = new Map();
			const otherProblems = [];
			const processedProblems = new Set();
			
			validOpinions.forEach(opinion => {
				const problem = opinion.confirmProblem.toString();
				const isSpecial = specialProblems.some(special => problem.includes(special));
				
				if (isSpecial) {
					let foundKey = null;
					for (const [key] of specialProblemMap.entries()) {
						if (specialProblems.some(special => key.includes(special) && problem.includes(special))) {
							foundKey = key;
							break;
						}
					}
					
					if (foundKey) {
						specialProblemMap.set(foundKey, `${specialProblemMap.get(foundKey)}、${problem}`);
					} else {
						specialProblemMap.set(problem, problem);
					}
				} else {
					if (!processedProblems.has(problem)) {
						processedProblems.add(problem);
						otherProblems.push(problem);
					}
				}
			});
			
			const specialArr = Array.from(specialProblemMap.values());
			return [...specialArr, ...otherProblems].join('；');
		},
		
		
		async xiangTiao  (id)  {
			const result = await getMergeOpinionSummaryReportListByStepOne({projectId:id})
			// console.log(result, 'result')
			const response = result.data.response
			const a1 = response? response.filter(item=>item.opinionSummaryList.length>1):[]
			const result1 = await getMergeOpinionSummaryReportListByStepTwo({projectId:id})
			// console.log(result1, 'result')
			const response1 = result1.data.response
			const a2 =response1? response1.filter(item => item.opinionSummaryReportList.length > 1):[]
			// if (response && response.length > 0) {
			//     response.forEach(item => {
			//         a1.push(item.opinionSummaryReportList)
			//         a4.push(item.opinionSummaryList.length>1)
			//     })
			// }
			// const a2=a1.filter(item=>item.filter(item=>item.opinionSummaryList.length>1))
			// const a3 = a4.filter(item=>item.length>1)
			console.log(a2,'a2')
			console.log(a1,'a1')
			
			this.tiaoLength=(a2.length>0)
			console.log(this.tiaoLength,'tiaoLength')
			this.xiangLength=(a1.length > 0)
			
		},
		
		async tiaoDialogs() {
			const stepOneResult = await getMergeOpinionSummaryReportListByStepOne({projectId:this.projectId});
			const stepOneResponse = stepOneResult.data.response;
			this.item = stepOneResponse.filter(item => item.opinionSummaryList.length > 1);
			this.opendTiao = true;
			this.opened = false;
		},
		userNames(names) {
			return names;
		},
		
		// 合并意见逻辑（原逻辑完整迁移）
		getMergedOpinion(item) {
			this.uniqueConfirmProblems.clear();
			
			// 特殊问题定义
			const specialProblems = [
				'未提供场所',
				'未提供符合消防法律法规和消防技术标准规定设计内容的场所',
				'未提供按照国家制图标准和图例绘制的场所'
			];
			
			// 过滤有效意见
			const validOpinions = item.opinionSummaryList.filter(opinion => opinion.confirmProblem);
			const specialProblemMap = new Map();
			const otherProblems = [];
			
			validOpinions.forEach(opinion => {
				const problem = opinion.confirmProblem.toString();
				const isSpecial = specialProblems.some(special => problem.includes(special));
				
				if (isSpecial) {
					let foundKey = null;
					for (const [key] of specialProblemMap.entries()) {
						if (specialProblems.some(special => key.includes(special) && problem.includes(special))) {
							foundKey = key;
							break;
						}
					}
					if (foundKey) {
						specialProblemMap.set(foundKey, `${specialProblemMap.get(foundKey)}、${problem}`);
					} else {
						specialProblemMap.set(problem, problem);
					}
				} else {
					if (!this.uniqueConfirmProblems.has(problem)) {
						this.uniqueConfirmProblems.add(problem);
						otherProblems.push(problem);
					}
				}
			});
			
			const specialArr = Array.from(specialProblemMap.values());
			return [...specialArr, ...otherProblems].join('；');
		},
		
		
		async generateReportEnd(){
			this.$confirm('是否生成报告?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(async () => {
				const idList = this.selectedList.map(item => item.id).join(',');
				let params = {
					projectId: this.projectId,
					idList: idList,
				};
				const result = await generatePreliminaryReviewReport(params);
				if (result.data.success) {
					this.$message.success("生成报告成功！");
					await this.handleProjectUpdate()
					this.reportDialog = false;
					
				}else {
					this.$message.error("生成报告失败：" + (result.data.message || "未知错误"));
				}
			}).catch(() => {
			
			})
		},
		async confirmOpinion () {
			await this.getConfirmOpinionList();
			this.confirmOpinionDialog = true;
			setTimeout(() => {
				const arr = this.confirmOpinionList.filter(item => item.isShow)
				this.toggleSelectionConfirm(arr)
			}, 500)
		},
		async getConfirmOpinionList(){
			let params = {
				projectId: this.projectId,
			};
			const result = await getOpinionSummaryReportList(params);
			if (result.data.success) {
				this.confirmOpinionList = result.data.response;
				
			} else {
				this.$message.error("获取意见汇总报告列表失败：" + (result.data.message || "未知错误"));
			}
		},
		async previewReport () {
			const idList = this.selectedList.map(item => item.id).join(',');
			let params = {
				projectId: this.projectId,
				idList: idList,
			};
			const result = await reportPreview(params);
			if (result) {
				const {status, success, response, message} = result.data;
				if (status === 200 && success === true) {
					this.pdfUrl = response;
					this.reportGenDialog = true;
				} else {
					this.$message.error("获取文件失败：" + (message || "未知错误"));
				}
			}
			
		},
		handleCurrentChange(val) {
			this.toggleSelection([val])
		},
		handleSelectionChange(val) {
			// this.selectedList = val;
			console.log(val, 'multipleSelection111')
		},
		async handleCurrentConfirmChange(val) {
			// this.toggleSelectionConfirm([val])
			await this.updateOpinion(val)
			await this.confirmOpinion ()
		},
		async updateOpinion(item){
			let params = {
				drProjectId:item.drProjectId,
				isShow:!item.isShow,
				reportId:item.id,
			}
			await updateShowOpinionSummaryReport(params)
		},
		handleSelectionConfirmChange(val) {
			// this.multipleSelection = val;
			console.log(val, 'multipleSelection')
		},
		toggleSelectionConfirm(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTableConfirm.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTableConfirm.clearSelection();
			}
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		async handleOnDelete(item){
			this.$confirm('确定要删除该条意见吗？删除后将无法恢复！', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then( async () => {
				let params = {
					id: item.id
				};
				const result = await deleteConfirmedOpinion(params);
				if (result.data.success) {
					this.$message.success("删除意见成功！");
					await this.getConfirmedOpinions(this.projectId);
					await this.getUnConfirmedOpinions(this.projectId);
				} else {
					this.$message.error("删除意见失败：" + (result.data.message || "未知错误"));
				}
			});
		},
		async handleOnEdit(item){
			this.editConfirmDialog = false;
			this.editConfirmDialog = true;
			this.editConfirmContent = item.confirmProblem;
			this.editConfirmId = item.id;
		},
		async handleOnConfirm(item){
			this.$confirm('确定要确认该条意见吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(  async () => {
				let params = {
					...item,
					
				};
				params.confirmProblem = this.editConfirmContent;
				const result = await updateConfirmedOpinion(params);
				if (result.data.success) {
					this.$message.success("确认意见成功！");
					await this.getConfirmedOpinions(this.projectId);
					this.handleOnCancle()
				} else {
					this.$message.error("确认意见失败：" + (result.data.message || "未知错误"));
				}
			});
		},
		 handleOnCancle(){
			this.editConfirmDialog = false;
			this.editConfirmContent = undefined;
			this.editConfirmId = undefined;
		},
		async	handleProjectUpdate() {
			this.projectLoading = true;
			this.activeName = '-';
			await this.init();
			this.projectLoading = false;
		},
		// 获取短路径
		 getShortPath (path)  {
			if (path && path.length > 0) {
				return path.replace(/(.*?)\/(.*?)\/(.*?)\//, '');
			}
			return path;
		},
		// 获取专家项目列表
		async getExpertProjectList() {
			try {
				this.loading = true;
				let params = {
					projectId: this.projectId,
					
				}
				this.editableTabs = [
					{
						userId: '-',
						userName: '自动汇总'
					}
				];
				const result = await getPeopleCount(params);
				if (result.data.success) {
					this.editableTabs.push(...result.data.response);
				}
			} catch (error) {
				this.$message.error("获取专家项目列表失败：" + (error.message || "未知错误"));
			} finally {
				this.loading = false;
			}
		},
		// 获取待确认专家单人列表
		async getUnConfirmedExpertList(id) {
			try {
				this.loading = true;
				let params = {
					projectId: this.projectId,
					userId:id,
				}
				const result = await getQuesTypeSummaryUnconfirmedForUser(params);
				if(result.data.success){
					this.unConfirmedOpinions = result.data.response;
					this.unConfirmedOpinions.forEach((item) => {
						if (item.opinionSummaryUnconfirmedList && item.opinionSummaryUnconfirmedList.length > 0)
							item.opinionSummaryUnconfirmedList.forEach(value => {
								value.drProjectFilePath = this.getShortPath(value.drProjectFilePath);
							})
					})
					
					
				}else{
					this.$message.error("获取待确认专家单人列表失败：" + (result.data.message || "未知错误"));
				}
			} catch (error) {
				this.$message.error("获取待确认专家单人列表失败：" + (error.message || "未知错误"));
			} finally {
				this.loading = false;
			}
		},
		handleClick(tab, event) {
			console.log(tab, event);
			this.activeName = tab.name;
			if (this.activeName === '-') {
				this.getUnConfirmedOpinions(this.projectId);
			}else {
				this.getUnConfirmedExpertList(tab.name);
			}
		},
		
		// 待确认审查意见列表
		async getUnConfirmedOpinions(id) {
			try {
				this.loading = true;
				const result = await getQuesTypeSummaryUnconfirmed({ projectId: id,flagLess2: true });
				this.unConfirmedOpinions = result.data.response;
				this.unConfirmedOpinions.forEach((item) => {
					if (item.opinionSummaryUnconfirmedList && item.opinionSummaryUnconfirmedList.length > 0)
						item.opinionSummaryUnconfirmedList.forEach(value => {
							value.drProjectFilePath = this.getShortPath(value.drProjectFilePath);
						})
				})
				
			} catch (error) {
				this.$message.error("获取待确认审查意见列表失败：" + (error.message || "未知错误"));
			} finally {
				this.loading = false;
			}
		},
		// 确认审查意见列表
		async getConfirmedOpinions(id) {
			try {
				this.loading = true;
				const result = await getDrOpinionSummaryConfirmed({ projectId: id });
				this.confirmedOpinions = result.data.response;
				this.confirmedOpinions.forEach((item) => {
					if (item.opinionSummaryConfirmedList && item.opinionSummaryConfirmedList.length > 0)
						item.opinionSummaryConfirmedList.forEach(value => {
							value.drProjectFilePath = this.getShortPath(value.drProjectFilePath);
						})
				})
				
			} catch (error) {
				this.$message.error("获取确认审查意见列表失败：" + (error.message || "未知错误"));
			} finally {
				this.loading = false;
			}
		},
		// 初始化项目列表
		async init() {
			try {
				this.loading = true;
				const result = await getProjectListByUngather();
				const response  = result.data.response;
				
				if (response && response.length > 0) {
					const data = response.map(item => ({
						label: item.projectName,
						projectNo: item.projectNo,
						value: item.id,
						isAllowMergeOpinionSummaryReport: item.isAllowMergeOpinionSummaryReport,
						id: item.id,
						ddIdNodeBizType: item.ddIdNodeBizType,
						standardIds: item.standardIds
					}));
					
					this.projectList = data;
					this.list = response;
					
					if (data&&data.length > 0) {
						this.projectId = data[0].id;
						await this.getUnConfirmedOpinions(data[0].id);
						await this.getConfirmedOpinions(data[0].id);
						await this.getExpertProjectList();
						await this.xiangTiao(data[0].id)
						this.curProject = data[0];
					}
				}
			} catch (error) {
				this.$message.error("初始化失败：" + (error.message || "未知错误"));
			} finally {
				this.loading = false;
			}
		},
		
		// 切换项目
		async handleProjectChange(val) {
			const curProject = this.projectList.find(item => item.value === val);
			this.curProject = curProject;
			this.projectId = curProject.id;
			await this.getUnConfirmedOpinions(curProject.id);
			await this.getConfirmedOpinions(curProject.id);
			await this.getExpertProjectList();
		},
		
		
		
		
		//简化意见
		opinionSimplification(){
			this.mergeOpinions();
			if (this.xiangLength) {
				this.opened = true;
			} else {
				this.opendTiao = true;
			}
		},
		//生成初审/复核报告
		async generateReport() {
			this.multipleSelection = [];
			
			await this.idList()
			await this.getStandardList()
			
			this.reportDialog = true;
			
			setTimeout(() => {
				this.toggleSelection(this.selectedList)
			}, 800)
		},
		async idList () {
			let params = {
				projectId:this.projectId
			}
			const result = await getProjectById(params);
			if (result.data.success) {
				this.standardIds = result.data.response.standardIds.split(',');
				console.log(this.standardIds, 'standardIds')
			} else {
				this.$message.error("获取项目失败：" + (result.data.message || "未知错误"));
			}
		},
		async getStandardList () {
			let params = {
				pageIndex:1,
				pageSize:1000,
				ddIdNodeBizType:1,
				sourceType:'winform'
			}
			const result = await getDrStandardList(params);
			if (result.data.success) {
				this.standardList = result.data.response.data;
				const arr = result.data.response.data.filter(item => this.standardIds.includes(item.id.toString()))
				console.log(arr, 'arr')
				this.selectedList = arr
				
				
			} else {
				this.$message.error("获取项目失败：" + (result.data.message || "未知错误"));
			}
		},
		// 合并意见核心方法
		async mergeOpinions() {
			if (!this.projectId) {
				return this.$message.warning("请先选择项目！");
			}
			try {
				this.loading = true;
				
				// 步骤二合并数据
				const stepTwoResult = await getMergeOpinionSummaryReportListByStepTwo({projectId:this.projectId});
				const stepTwoResponse = stepTwoResult.data.response;
				this.items = stepTwoResponse.filter(item => item.opinionSummaryReportList.length > 1);
				
				// 步骤一合并数据
				const stepOneResult = await getMergeOpinionSummaryReportListByStepOne({projectId:this.projectId});
				const stepOneResponse = stepOneResult.data.response;
				this.item = stepOneResponse.filter(item => item.opinionSummaryList.length > 1);
				console.log(this.items,'itemsddddd')
				
				// 无数据提示
				if (!this.items.length && !this.item.length) {
					this.$message.info("当前项目暂无需要合并的意见！");
				}
				
			} catch (error) {
				this.$message.error("合并意见失败：" + (error.message || "未知错误"));
			} finally {
				this.loading = false;
			}
		},
		
		// 编辑步骤一意见
		async onEditQuestion(item) {
			try {
				// await sendingAll("", "汇总意见-合并项-编辑", this.projectId, false, undefined);
				this.editIdQ = item.id;
				
				if (item.confirmProblem) {
					this.editValueQuestion = item.confirmProblem;
				} else {
					// 去重处理
					const uniqueConfirmProblems = new Set();
					const uniqueItems = item.opinionSummaryList
							.filter(i => i.confirmProblem)
							.filter(i => {
								const str = i.confirmProblem.toString();
								if (!uniqueConfirmProblems.has(str)) {
									uniqueConfirmProblems.add(str);
									return true;
								}
								return false;
							});
					
					this.editValueQuestion = uniqueItems.map(i => i.confirmProblem.toString()).join("；");
				}
			} catch (error) {
				this.$message.error("编辑失败：" + error.message);
			}
		},
		
		// 编辑步骤二意见
		onEditQuestionTiao(item) {
			// sendingAll("", "编辑条内容", this.projectId, false, undefined);
			this.editIdQ = item.id;
			
			if (item.confirmProblem && item.confirmProblem !== "null") {
				this.editValueQuestion = item.confirmProblem;
			} else {
				const uniqueConfirmProblems = new Set();
				const uniqueItems = item.opinionSummaryReportList
						.filter(i => i.confirmProblem)
						.filter(i => {
							const str = i.confirmProblem.toString();
							if (!uniqueConfirmProblems.has(str)) {
								uniqueConfirmProblems.add(str);
								return true;
							}
							return false;
						});
				
				this.editValueQuestion = uniqueItems.map(i => i.confirmProblem.toString()).join("；");
			}
		},
		
		// 取消编辑
		async onCancelQ() {
			// await sendingAll("", "汇总意见-合并项-取消", this.projectId, undefined, undefined);
			this.editIdQ = undefined;
			this.editValueQuestion = "";
		},
		
		// 保存合并意见
		async onSaveMerg(item) {
			try {
				if (!this.editValueQuestion || this.editValueQuestion.trim() === "") {
					return this.$message.error("描述问题不能为空且不能为纯空格！");
				}
				
				if (item.confirmProblem === this.editValueQuestion.trim()) {
					this.editIdQ = undefined;
					this.editValueQuestion = "";
					return this.$message.info("未修改意见内容，无需保存！");
				}
				
				const _temp = { ...item, confirmProblem: this.editValueQuestion.trim() };
				const result = await updateConfirmProblemByOpinionSummaryReport(_temp);
				
				// 额外处理reportId
				const temps = {
					confirmProblem: "null",
					ddIdQuestionPropertie: item.ddIdQuestionPropertie,
					ddIdQuestionType: item.ddIdQuestionType,
					id: item.reportId
				};
				await updateConfirmProblemByOpinionSummaryReport(temps);
				
				if (result.data.success && result.data.status === 200) {
					this.$message.success("保存成功");
					this.editIdQ = undefined;
					this.editValueQuestion = "";
					// 重新加载数据
					await this.mergeOpinions();
				} else {
					this.$message.error(result.data.message || "服务器错误");
				}
			} catch (error) {
				this.$message.error("保存失败：" + error.message);
			}
		},
		
		// 删除确认意见
		async onConfirm(value) {
			// await sendingAll("", "汇总意见-已确认-删除", this.projectId, false, undefined);
			this.open = true;
			this.removeOpinion = value;
		},
		
		// 取消删除
		handleDeleteCancel() {
			this.open = false;
		},
		
		// 执行删除
		async _deleteOpinion() {
			try {
				this.open = false;
				if (!this.removeOpinion) return;
				
				const loading = this.$loading({
					lock: true,
					text: "删除中...",
					spinner: "el-icon-loading",
					background: "rgba(0, 0, 0, 0.7)"
				});
				
				const result = await deleteConfirmedOpinion(this.removeOpinion.id);
				loading.close();
				
				if (result.data.status === 200 && result.data.success) {
					this.$message.success("删除成功");
					this.opinions = this.opinions.filter(e => e.id !== this.removeOpinion.id);
					await this.getUnConfirmedOpinions(this.projectId);
					await this.getConfirmedOpinions(this.projectId);
				} else {
					this.$message.error(result.data.message || "删除失败");
				}
			} catch (error) {
				this.$message.error("删除失败：" + error.message);
			}
		},
		// 确认待确认意见
		async handleOnAdd(value){
			
			this.$confirm('是否确认该意见？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const res = await addOpinionConfirmed({id:value.id,qualityType:1});
				if (res.data.success && res.data.status === 200) {
					this.$message.success("确认成功");
					await 	this.getConfirmedOpinions(this.projectId);
					if (this.activeName === '-'){
						await this.getUnConfirmedOpinions(this.projectId);
					}else {
						await  this.getUnConfirmedExpertList(this.activeName)
					}
					
				} else {
					this.$message.error(res.data.message || "确认失败");
				}
			});
		},
		async handleOnAddConfirm(value){
			
			this.$confirm('是否认可该意见？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				const res = await addOpinionConfirmed({id:value.id,qualityType:2});
				if (res.data.success && res.data.status === 200) {
					this.$message.success("确认成功");
					await 	this.getConfirmedOpinions(this.projectId);
					if (this.activeName === '-'){
						await this.getUnConfirmedOpinions(this.projectId);
					}else {
						await  this.getUnConfirmedExpertList(this.activeName)
					}
					
				} else {
					this.$message.error(res.data.message || "确认失败");
				}
			});
		},
		// 预览图片
		async handlePreview(opinion) {
			// await sendingAll("", "查看截图", this.projectId, false, undefined);
			if (!opinion?.positionImg) {
				return this.$message.warning("暂无截图可预览！");
			}
			this.previewImage = opinion.positionImg;
			this.previewOpen = true;
			this.previewTitle = opinion.drawingName;
		},
		
		// 关闭预览
		handleCancel() {
			this.previewOpen = false;
			this.previewImage = ""; // 清空图片地址，避免下次预览显示旧图
		},
		
		// // 占位方法（需根据实际业务补充）
		// async getUnconfirmedOpinion() {},
		// async getConfirmedOpinion() {},
		// async xiangTiao() {},
		handleOpinionChangeQuestion(e) {
			this.editValueQuestion = e.target.value;
		}
	}
};
</script>

<style scoped>

/* 弹窗高度 80vh */
.tiao-dialog {
	height: 80vh;
}
/* 内容区域滚动 */
.modal-content {
	height: 100%;
	overflow-y: auto;
	padding: 0 10px;
}
/* 列表标题 */
.list-title {
	font-weight: 500;
	margin-bottom: 10px;
}
/* 描述间距 */
.list-desc {
	line-height: 1.6;
}
/* 单个意见项 */
.opinion-item {
	margin-bottom: 8px;
	display: flex;
	align-items: center;
	gap: 8px;
}
/* 意见内容 */
.opinion-content {
	margin-left: 8px;
}
/* 合并意见 */
.merge-opinion {
	margin: 15px 0;
	display: flex;
	align-items: center;
	gap: 8px;
}
/* 编辑按钮区域 */
.edit-btns {
	margin-top: 10px;
}
/* 编辑文本域 */
.edit-textarea {
	margin-bottom: 10px;
}
/* 按钮组 */
.btn-group {
	display: flex;
	gap: 10px;
}
/* 底部按钮 */
.dialog-footer {
	text-align: right;
}


.tag-itemType{
	
	color: white ;
	padding: 0 5px;
	border-radius: 3px;
	white-space: nowrap;
}
/* 内容容器 */
.collect-list {
	background: #f5f7fa;
}

/* 空状态容器 */
.collect-list .empty-container {
	padding: 40px 0;
}

/* 搜索表单 */
.collect-list .search-form {
	background: #fff;
	padding: 16px 24px;
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);
	margin-bottom: 16px;
	
}

/* 操作按钮容器 - 原有样式保留 */
.collect-list .operate-btn-container {
	padding: 0 24px 16px;
}

/* 操作按钮容器 - 改为底部居中 */
 .operate-btn-container {
	text-align: center;
}

/* 按钮本身居中微调（可选） */
.collect-list .operate-btn-container .el-button {
	display: inline-block;
}

/* 意见卡片 */
.collect-list .opinion-card {
	border-radius: 4px;
}
.collect-list .opinion-card .card-header {
	display: flex;
	align-items: center;
}
.collect-list .opinion-card .card-header .card-title {
	font-size: 16px;
	font-weight: 500;
	color: #333;
}

/* 标签项 */
.collect-list .tag-item {
	margin-right: 8px;
	margin-bottom: 8px;
	white-space: nowrap;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* 编辑文本域 */
.collect-list .edit-textarea {
	width: 100%;
}

/* 合并后内容展示 */
.collect-list .merged-content {
	line-height: 1.6;
	color: #666;
	word-break: break-all;
	padding: 4px 0;
}

/* 预览图片容器 */
.collect-list .preview-img-container {
	width: 100%;
	text-align: center;
}
.collect-list .preview-img-container img {
	max-width: 100%;
	max-height: 700px;
	object-fit: contain;
}
.collect-list .preview-img-container .img-loading {
	opacity: 0;
}

/* 删除提示弹窗样式 */
.collect-list .delete-tip {
	display: flex;
	align-items: flex-start;
	padding: 8px 0 24px;
}
.collect-list .delete-tip .delete-icon {
	margin-right: 8px;
	margin-top: 2px;
}
.collect-list .delete-tip span {
	font-size: 14px;
	color: #666;
	line-height: 1.6;
}

/* 弹窗底部 */
.collect-list :deep(.dialog-footer) {
	text-align: right;
}

/* 间距类 */
.collect-list .mt-20 {
	margin-top: 20px;
}
.collect-list .ml-8 {
	margin-left: 8px;
}

/* 表格单元格样式优化 */
.collect-list :deep(.el-table__cell) {
	padding: 12px 8px;
}

/* 按钮样式优化 */
.collect-list :deep(.el-button--mini) {
	padding: 4px 8px;
}
</style>